import React, { CSSProperties, useContext } from "react";
import cx from "classnames";
import { EntityMenuContext } from "shared/ui/entity/entity-menu-context";
import { DotsVertical } from "shared/ui/icon";
import { Menu, MenuButton, MenuContainer } from "shared/ui/menu";
import styles from "./entity-actions.module.scss";

export interface IEntityActions {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const EntityActions = (props: IEntityActions) => {
  const menuItems = useContext(EntityMenuContext);

  return (
    <div className={cx(styles.entity_actions, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
      {menuItems && (
        <div className={styles.menu_button}>
          <MenuContainer placement="bottom-end">
            <MenuButton size="small" svgOnly variant="unstyled">
              <DotsVertical />
            </MenuButton>

            <Menu minWidth={150}>{menuItems}</Menu>
          </MenuContainer>
        </div>
      )}
    </div>
  );
};

EntityActions.defaultProps = {};
